// src/pages/PrivacyPolicy.js

import React, { useEffect } from 'react';

function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={styles.pageWrapper}>
      
      {/* Hero Section */}
      <section style={styles.heroSection}>
        <div style={styles.heroContent}>
          <h1 style={styles.heroTitle}>Terms of Use & Privacy Policy</h1>
          <p style={styles.heroSubtitle}>
            Please read these terms and conditions carefully before using our website.
          </p>
        </div>
      </section>

      {/* Main Content Section */}
      <section style={styles.mainSection}>
        <div style={styles.contentCard}>
          
          <div style={styles.sectionBlock}>
            <h2 style={styles.sectionTitle}>1. Using the website</h2>
            <p style={styles.paragraph}>
              By using our Website, you are deemed to have accepted the following terms and conditions. We reserve the right to change these terms and conditions at any time, and you are advised to review these terms regularly to ensure you are aware of any changes. Your continued use of the Website after such changes are posted will be deemed agreement on your part to these terms and conditions as amended.
            </p>
          </div>

          <div style={styles.sectionBlock}>
            <h2 style={styles.sectionTitle}>2. Intellectual property</h2>
            <div style={styles.subSection}>
              <h3 style={styles.subHeading}>2.1</h3>
              <p style={styles.paragraph}>
                Copyright and all intellectual property rights in the content of the website are vested in NAPREV and reserved, unless indicated otherwise. The content of the Website belongs to NAPREV unless indicated otherwise. You may use the content of the Website subject to the following conditions:
              </p>
              <ul style={styles.list}>
                <li style={styles.listItem}>(a) It is used for information purposes only.</li>
                <li style={styles.listItem}>(b) It is used only for your own personal, non-commercial use.</li>
                <li style={styles.listItem}>(c) Any copies or downloads of any content from the Website must include a notice that copyright in the relevant material is owned by NAPREV.</li>
              </ul>
            </div>
            <div style={styles.subSection}>
              <h3 style={styles.subHeading}>2.2</h3>
              <p style={styles.paragraph}>
                Except as expressly provided above, nothing contained on this Website should be construed as conferring any licence or right to use any trademark or copyright of NAPREV's or any third party.
              </p>
            </div>
          </div>

          <div style={styles.sectionBlock}>
            <h2 style={styles.sectionTitle}>3. Submission of comments/contributions to the website and NAPREV's blogs</h2>
            
            <div style={styles.subSection}>
              <h3 style={styles.subHeading}>3.1</h3>
              <p style={styles.paragraph}>You may submit comments to NAPREV, including without limitation for publication on our Blogs.</p>
            </div>

            <div style={styles.subSection}>
              <h3 style={styles.subHeading}>3.2</h3>
              <p style={styles.paragraph}>
                Any comments submitted in connection with our Blogs are submitted on the basis that we will review and may edit such comments prior to publication on the Website, and that not all submissions will be published. Publication is entirely at the discretion of NAPREV. We accept no responsibility or liability in relation to the content of any material posted or published on this Website by third parties or in relation to contributions by third parties which we publish on the Website. You are entirely liable for all activities conducted by you or by others authorized by you or otherwise on your behalf.
              </p>
            </div>

            <div style={styles.subSection}>
              <h3 style={styles.subHeading}>3.3</h3>
              <p style={styles.paragraph}>
                If and to the extent that you submit any personal data (such as your name and email address) to NAPREV through the Blogs, NAPREV confirms that it will only use any such personal data for the purposes for which you have provided it.
              </p>
            </div>

            <div style={styles.subSection}>
              <h3 style={styles.subHeading}>3.4</h3>
              <p style={styles.paragraph}>
                Any communications which we receive from you in connection with the Blogs and any material that you transmit or post or submit via this Website will be deemed non-confidential and non-proprietary and we reserve the right to use the content of such communications for any purpose whatsoever. In relation to such contributions you grant us a perpetual, royalty-free, non-exclusive, sub-licensable right and license to use, reproduce, modify, adapt, edit, publish and exercise all copyright and publicity rights with respect to such work world-wide and/or to incorporate it in other works in any media now known or later developed for the full term of any rights that may exist in such content, consistent with the privacy restrictions set forth in the Privacy Policy. If you do not wish to grant such rights to NAPREV please do not submit your contribution to this Website. By submitting your contribution to this website, you also:
              </p>
              <ul style={styles.nestedList}>
                <li style={styles.nestedListItem}>
                  <strong>3.4.1</strong> Warrant that such contribution is your own original work and that you have the right to make it available to us for all the purposes specified above.
                </li>
                <li style={styles.nestedListItem}>
                  <strong>3.4.2</strong> Warrant that such contribution is not defamatory, does not infringe the rights of any third party and does not infringe any law.
                </li>
                <li style={styles.nestedListItem}>
                  <strong>3.4.3</strong> Agree to use this Website only for lawful purposes and in a manner that does not restrict or inhibit the use and enjoyment of this Website by any third party. Prohibited behavior includes, without limitation, conduct which is unlawful or which may harass or cause distress to any person and the submission or transmission of content, which is defamatory, abusive, obscene, offensive, pornographic, indecent, discriminatory, inflammatory, in breach of confidence or privacy or which in the opinion of NAPREV may cause offence to any person or damage our reputation. You must not use any abusive or aggressive language, swear, threaten, harass or abuse any other person, including other users.
                </li>
                <li style={styles.nestedListItem}>
                  <strong>3.4.4</strong> Agree to indemnify, defend and hold harmless NAPREV against any claim, liability, cost, damage, or loss we may incur (including without limitation legal fees) as a result of any violation by you of the provisions set out in this clause 3.
                </li>
                <li style={styles.nestedListItem}>
                  <strong>3.4.5</strong> Agree to waive any moral rights in your contribution for the purposes of its submission to and publication on the Website and other purposes specified above.
                </li>
              </ul>
            </div>

            <div style={styles.subSection}>
              <h3 style={styles.subHeading}>3.5</h3>
              <p style={styles.paragraph}>You must not intentionally violate any laws, rules or regulations.</p>
            </div>

            <div style={styles.subSection}>
              <h3 style={styles.subHeading}>3.6</h3>
              <p style={styles.paragraph}>
                No user must post nor recommend any other Website nor refer to specific URLs (Website addresses) where those linked Websites would infringe any of the above provisions. No user must post any advertisement on the Website.
              </p>
            </div>

            <div style={styles.subSection}>
              <h3 style={styles.subHeading}>3.7</h3>
              <p style={styles.paragraph}>
                In using this Website, you agree not to impersonate another person or use a false name or a name you are unauthorized to use or create a false email address or try to mislead others as to the identity or origin of any communication.
              </p>
            </div>

            <div style={styles.subSection}>
              <h3 style={styles.subHeading}>3.8</h3>
              <p style={styles.paragraph}>
                NAPREV reserves the right to take any action against any account or user, at any time, for any reason. We may at our discretion terminate your access to the Website or to the registration areas of the Website or prevent you from submitting comments via the Website immediately, and without giving you advance notice. If you engage in behavior which breaches these terms and conditions, and we consider such behavior to be serious and/or repeated, we may use whatever information is available to us to prevent further breaches. If your access to the Website or to registration areas of the Website is terminated, you may not open another account with us or register again, and we reserve the right to terminate any such account or cancel any such registration.
              </p>
            </div>

            <div style={styles.subSection}>
              <h3 style={styles.subHeading}>3.11</h3>
              <p style={styles.paragraph}>
                Should you have any complaint regarding any material published on the website; you can notify us of the nature and details of your complaint by emailing <a href="mailto:workforceus2016@gmail.com" style={styles.link}>workforceus2016@gmail.com</a>.
              </p>
            </div>
          </div>

          <div style={styles.sectionBlock}>
            <h2 style={styles.sectionTitle}>4. Data Collection, Cookies, and IP Tracking</h2>
            <p style={styles.paragraph}>
              When you interact with our Website, we may automatically collect standard technical information to ensure secure and optimized delivery of our services. With your explicit consent via our cookie banner, this collected data includes your Internet Protocol (IP) address, browser type, operating system, and timestamps of your visit. We utilize this information strictly for internal security audits, consent logging, and performance analytics. You retain the right to decline non-essential tracking at any time by clearing your browser cookies associated with NAPREV.
            </p>
          </div>

          <div style={styles.disclaimerBlock}>
            <h2 style={styles.disclaimerTitle}>Disclaimer</h2>
            <p style={styles.disclaimerText}>
              This website and any of the material contained therein is intended to provide general information only and is not intended to constitute any specific professional advice or services. It is not an exhaustive treatment of a particular subject or subjects, nor does it create a business or professional services relationship. The information contained herein is not intended to constitute accounting, tax, investment, legal or other professional advice or services. The material discussed is meant to provide general information and should not be acted on without obtaining professional advice appropriately tailored to your individual needs. Your use of this website and the information it contains is at your own risk. Before making any decisions or taking any action that might affect your personal business or finances, you should consult a qualified professional adviser.
            </p>
          </div>

        </div>
      </section>
    </div>
  );
}

const styles = {
  pageWrapper: {
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#F4F7F9',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column'
  },
  heroSection: {
    backgroundColor: '#002B49',
    backgroundImage: 'linear-gradient(135deg, #002B49 0%, #001524 100%)',
    padding: '60px 5%',
    textAlign: 'center',
    color: '#FFFFFF',
    borderBottom: '4px solid #E1261C'
  },
  heroContent: {
    maxWidth: '800px',
    margin: '0 auto'
  },
  heroTitle: {
    fontSize: '38px',
    fontWeight: 'bold',
    marginBottom: '15px',
    letterSpacing: '-0.5px'
  },
  heroSubtitle: {
    fontSize: '18px',
    lineHeight: '1.6',
    color: '#D1D5DB'
  },
  mainSection: {
    padding: '60px 5% 100px',
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center'
  },
  contentCard: {
    backgroundColor: '#FFFFFF',
    width: '100%',
    maxWidth: '1000px',
    padding: '50px 60px',
    borderRadius: '12px',
    boxShadow: '0 10px 25px -5px rgba(0, 43, 73, 0.05)',
    border: '1px solid #E5E7EB',
  },
  sectionBlock: {
    marginBottom: '45px'
  },
  sectionTitle: {
    fontSize: '24px',
    color: '#002B49',
    fontWeight: 'bold',
    marginBottom: '20px',
    borderBottom: '2px solid #F3F4F6',
    paddingBottom: '10px'
  },
  subSection: {
    marginBottom: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  subHeading: {
    fontSize: '18px',
    color: '#E1261C',
    fontWeight: 'bold',
    margin: '0'
  },
  paragraph: {
    fontSize: '16px',
    lineHeight: '1.8',
    color: '#4B5563',
    margin: 0,
    textAlign: 'justify'
  },
  list: {
    margin: '10px 0 0 20px',
    padding: 0,
    listStyleType: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
  },
  listItem: {
    fontSize: '16px',
    lineHeight: '1.7',
    color: '#4B5563',
  },
  nestedList: {
    margin: '15px 0 0 20px',
    padding: 0,
    listStyleType: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px'
  },
  nestedListItem: {
    fontSize: '16px',
    lineHeight: '1.7',
    color: '#4B5563',
    textAlign: 'justify'
  },
  link: {
    color: '#E1261C',
    textDecoration: 'none',
    fontWeight: 'bold'
  },
  disclaimerBlock: {
    marginTop: '60px',
    backgroundColor: '#F9FAFB',
    padding: '30px',
    borderRadius: '8px',
    borderLeft: '5px solid #002B49'
  },
  disclaimerTitle: {
    fontSize: '22px',
    color: '#002B49',
    fontWeight: 'bold',
    marginBottom: '15px',
    marginTop: 0
  },
  disclaimerText: {
    fontSize: '15px',
    lineHeight: '1.8',
    color: '#6B7280',
    margin: 0,
    textAlign: 'justify'
  }
};

export default PrivacyPolicy;